export default __webpack_public_path__ + "static/media/hanukkah-banner.cedd6205.png";